export const getOS = () => {
  return (window.SPECTRA_LOGIC_VAIL_INITIAL_STATE || {}).os;
};
